import { Loader } from '@amagimedia/amagi-design-system';
import { ReactElement, VFC } from 'react';
import { IBlipConfig } from '../apis/blip';
import { useGetBlipConfig } from '../hooks/blip';

interface IProps {
  channelId: number;
  accountDomain: string;
  render: (blipConfig: IBlipConfig) => ReactElement;
}

export const BlipConfigLoader: VFC<IProps> = (props) => {
  const queryRes = useGetBlipConfig(props.channelId, props.accountDomain);

  if (queryRes.isLoading) {
    return <Loader message="Loading configs" />;
  }

  if (queryRes.isIdle || queryRes.isError) {
    return null;
  }

  return props.render(queryRes.data.data);
};
